var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { staticClass: "icon-container" },
    [
      _c("img", {
        staticClass: "icon-image",
        style: { width: _vm.iconWidth, height: _vm.iconHeight },
        attrs: {
          src: require(`@/drc/assets/icons/${_vm.imageName}`),
          alt: "icon"
        },
        on: {
          mouseover: function($event) {
            return _vm.hoverIn()
          },
          mouseout: function($event) {
            return _vm.hoverOut()
          },
          click: _vm.iconClick
        }
      }),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.displayHint
          ? _c("span", { staticClass: "icon-tooltip" }, [
              _vm._v(" " + _vm._s(_vm.hoverText) + " ")
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }